'use strict'

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import MobileQueues from './views/mobile/Queues.vue'
import MobileQueueDetails from './views/mobile/QueueDetails.vue'
import MobileUnpauser from './views/mobile/Unpauser.vue'

import InstalledBase from './views/installed-base/Main2.vue'
import ClientHome from './views/clients/home/Home.vue'
import OrgHome from './views/orgs/home/Home.vue'
// import OrgHome from './views/orgs/home/Main.vue'
import VehicleHome from './views/vehicle/Home.vue'
import TechniciansList from './views/setup/technicians/List.vue'
import PapermanList from './views/tools/paperman/Main2.vue'
import CanSniffer from './views/tools/can-sniffer/Main.vue'
import CANDictsList from './views/setup/can-dict/List.vue'
import WifiNetworkList from './views/setup/wifi/NetworkList.vue'
import ClientsHealth from './views/health/clients/Main.vue'
import RawdataInspector from './views/rawdata/Main.vue'
import CamerasList from './views/setup/cameras/List.vue'
import CameraDetailsPage from './views/setup/cameras/DetailsPage.vue'
import KeyboardsList from './views/setup/keyboards/List.vue'
import KeyboardDetailsPage from './views/setup/keyboards/DetailsPage.vue'
import GlobalCameraHistory from './views/setup/cameras/GlobalCameraHistory.vue'
import MultiproductCostCenterReport from './views/multiproduct-measure/MultiproductCostCenterReport.vue'
import MultiproductTechnicianReport from './views/multiproduct-measure/MultiproductTechnicianReport.vue'
import MultiproductHealthReport from './views/multiproduct-measure/MultiproductHealthReport.vue'
import CustomersList from './views/customers/List.vue'
import CustomerHome from './views/customers/home/Main.vue'
import DiffViewer from './views/tools/DiffViewer.vue'
import TimelineViewer from './views/tools/TimelineViewer.vue'
import PathsViewer from './views/tools/PathsViewer.vue'
import PointsViewer from './views/tools/PointsViewer.vue'
import ProjectFilesList from './views/setup/project-files/List.vue'

import _ from 'lodash'

function r(path, component, props = false) {
  return { path, component, props }
}

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    r('/health/queues', require('./views/health/queues/Queues').default),
    r('/health/mirrors', require('./views/health/mirrors/Mirrors').default),

    { path: '/health/clients', component: ClientsHealth },

    { path: '/installed-base', component: InstalledBase },
    // r('/installed-base', require('./views/installed-base/Main').default),

    r('/rawdata/parser', require('./views/rawdata/Parser').default),
    r('/rawdata/writer', require('./views/rawdata/Writer').default),

    { path: '/rawdata/inspector', component: RawdataInspector },

    r(
      '/setup/sysconfigs',
      require('./views/setup/sysconfigs/SysConfigs').default
    ),
    r('/setup/sim-cards', require('./views/setup/sim-cards/Main').default),

    // r('/setup/technicians', require('./views/setup/technicians/List').default),
    { path: '/setup/technicians', component: TechniciansList },
    {
      path: '/setup/technicians/:id',
      component: require('./views/setup/technicians/Main.vue').default,
      props: true
    },

    { path: '/setup/project-files', component: ProjectFilesList },

    { path: '/setup/cameras', component: CamerasList },
    { path: '/setup/cameras/:id', component: CameraDetailsPage, props: true },
    { path: '/history/cameras', component: GlobalCameraHistory },

    { path: '/setup/keyboards', component: KeyboardsList },
    {
      path: '/setup/keyboards/:id',
      component: KeyboardDetailsPage,
      props: true
    },

    { path: '/setup/can-dicts', component: CANDictsList },
    { path: '/setup/wifi/networks', component: WifiNetworkList },

    r('/setup/firmwares', require('./views/setup/firmwares/List').default),
    r(
      '/setup/brand-models',
      require('./views/setup/brand-models/List').default
    ),
    r(
      '/setup/vehicle-owners',
      require('./views/setup/vehicle-owners/List').default
    ),
    r('/setup/depots', require('./views/setup/depots/List').default),
    r(
      '/setup/audio/messages',
      require('./views/setup/audio/AudioMessages').default
    ),
    r('/setup/audio/sets', require('./views/setup/audio/AudioSets').default),

    r(
      '/setup/screen-sets',
      require('./views/setup/screens/ScreenSets').default
    ),
    r(
      '/setup/screen-sets/:id',
      require('./views/setup/screens/ScreenSet').default,
      true
    ),

    r('/billing/items', require('./views/billing-items/List.vue').default),
    r(
      '/billing/measure-v2',
      require('./views/cost-centers/measure-v2/List.vue').default
    ),

    {
      path: '/billing/multiproduct/cost-center',
      component: MultiproductCostCenterReport
    },
    {
      path: '/billing/multiproduct/technician',
      component: MultiproductTechnicianReport
    },
    {
      path: '/billing/multiproduct/health',
      component: MultiproductHealthReport
    },

    r(
      '/billing/cost-centers',
      require('./views/cost-centers/list/CostCenters.vue').default
    ),
    r(
      '/billing/cost-centers/:id',
      require('./views/cost-centers/home/Home.vue').default,
      true
    ),

    r('/beeper/sources', require('./views/beeper/Sources').default),
    r(
      '/beeper/subscriptions',
      require('./views/beeper/subscriptions/List').default
    ),
    r(
      '/beeper/timeline',
      require('./views/beeper/timeline/Timeline').default,
      (route) => {
        return {
          sources: route.query.sources,
          tags: route.query.tags
        }
      }
    ),

    r('/tools/history', require('./views/tools/GlobalClientHistory').default),

    // r('/tools/paperman', require('./views/tools/paperman/Main').default),
    { path: '/tools/paperman', component: PapermanList },

    r(
      '/tools/rd-events-history',
      require('./views/rdevents-history/GlobalRDEventsHistory').default
    ),
    r('/tools/fwupdates', require('./views/fwupdates/GlobalFWUpdates').default),

    r('/heartbeats/:hbid', require('./views/heartbeats/Main').default, true),

    {
      path: '/customers/list',
      component: CustomersList
    },

    {
      path: '/customers/:id',
      component: CustomerHome,
      props: true
    },

    r('/clients/list', require('./views/clients/list/Main').default),

    {
      path: '/clients/:cid',
      component: ClientHome,
      props: true
    },

    {
      path: '/vehicles/:orgId/:vehicleId',
      component: VehicleHome,
      props: (route) => {
        return {
          orgId: +route.params.orgId,
          vehicleId: +route.params.vehicleId
        }
      }
    },

    {
      path: '/vehicles/:vehicleId',
      component: VehicleHome,
      props: true
    },

    r('/orgs', require('./views/orgs/list/Main').default),

    {
      path: '/orgs/:code',
      component: OrgHome,
      props: true
    },

    r(
      '/orgs/:orgCode/trip/:tripId',
      require('./views/vis/VisPage').default,
      true
    ),

    r(
      '/tools/redis-browser',
      require('./views/tools/redis/Browser').default,
      true
    ),
    r(
      '/tools/gateman/accounts',
      require('./views/tools/gateman/Accounts').default,
      true
    ),
    r(
      '/tools/gateman/accounts/:accountId',
      require('./views/tools/gateman/Account').default,
      true
    ),
    r(
      '/tools/gateman/tokens',
      require('./views/tools/gateman/Tokens').default,
      true
    ),

    r('/tools/dashtest', require('./views/tools/dashtest/Main').default, true),
    r('/tools/tasklist', require('./views/tools/tasklist/Main').default, true),

    { path: '/tools/can-sniffer', component: CanSniffer },

    { path: '/', redirect: '/health/queues' },

    { path: '/mobile/queues', component: MobileQueues },
    {
      path: '/mobile/queues/:qname(.+)',
      component: MobileQueueDetails,
      props: true
    },
    {
      path: '/mobile/unpauser/:clientId',
      component: MobileUnpauser,
      props: true
    },

    { path: '/tools/diff-viewer', component: DiffViewer },
    { path: '/tools/timeline-viewer', component: TimelineViewer },
    { path: '/tools/paths-viewer', component: PathsViewer },
    { path: '/tools/points-viewer', component: PointsViewer }
  ]
})

// router.beforeEach((to, from, next) => {
//   let isMobile = window.innerWidth < 600
//   if (isMobile && !to.path.startsWith('/mobile')) {
//     next({ path: '/mobile/queues' })
//   } else {
//     next()
//   }
// })

router.afterEach((to /*, from*/) => {
  let title = _.get(to, 'matched[0].components.default.pageTitle')
  if (title == null) title = to.title || process.env.VUE_APP_TITLE
  document.title = title
})

export default router
